import { createStyles, makeStyles } from '@material-ui/core';
import type { StandardDivProps } from '@sprinx/react-mui-components';
import React from 'react';
import clsx from 'clsx';

type SimpleImageProps = StandardDivProps<SimpleImageClassNameKey> & {
  alt: string;
  src: string;
  title?: string;
};

type SimpleImageClassNameKey = 'root';

const useStyles = makeStyles(() =>
  createStyles<SimpleImageClassNameKey, {}>({
    root: {},
  }),
);
const SimpleImage: React.FC<SimpleImageProps> = ({ className, classes: pClasses, alt, src, title }) => {
  const classes = useStyles({ classes: pClasses });
  return <img className={clsx(classes.root, className)} src={src} alt={alt} title={title || alt} />;
};

SimpleImage.displayName = 'SimpleImage';

export default SimpleImage;
